import { base64 } from '@scure/base';
import { MAX_INSCRIPTION_FILE_BYTES } from './batch';
const key='stc:studio-inscription';
interface Handoff { name:string; type:string; bytes:string; title:string; metadata:string }
export async function saveStudioHandoff(blob:Blob,name:string,title:string,metadata:unknown) {
 if(blob.size>MAX_INSCRIPTION_FILE_BYTES)throw new Error('This edition exceeds 400 KB. Reduce the canvas size or use recursive HTML.');
 const handoff:Handoff={name,type:blob.type,bytes:base64.encode(new Uint8Array(await blob.arrayBuffer())),title,metadata:JSON.stringify(metadata)};
 sessionStorage.setItem(key,JSON.stringify(handoff));
}
export function readStudioHandoff():{file:File;bytes:Uint8Array;title:string;metadata:string}|null {
 const raw=sessionStorage.getItem(key);if(!raw)return null;
 const h=JSON.parse(raw) as Handoff;
 if(typeof h.bytes!=='string'||h.bytes.length>550000||typeof h.name!=='string'||typeof h.title!=='string'||typeof h.metadata!=='string'||!['image/png','text/html'].includes(h.type))throw new Error('The Studio handoff is invalid. Export the edition again.');
 const bytes=base64.decode(h.bytes);if(bytes.length>MAX_INSCRIPTION_FILE_BYTES)throw new Error('Studio edition exceeds 400 KB');
 return {file:new File([Uint8Array.from(bytes)],h.name,{type:h.type}),bytes,title:h.title,metadata:h.metadata};
}
